module.exports = __webpack_public_path__ + "118ef9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/BasicHeader/spirotech_new_logo.png
// module id = 1113
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20